var map = {
	"./News01.vue": [
		"91e0",
		"chunk-44433a7c"
	],
	"./News02.vue": [
		"3dee",
		"chunk-7da832ec"
	],
	"./News03.vue": [
		"c9bf",
		"chunk-568a1cbc"
	],
	"./News05.vue": [
		"f853",
		"chunk-2693d4d3"
	],
	"./News07.vue": [
		"db12",
		"chunk-784eca32"
	],
	"./News09.vue": [
		"253b",
		"chunk-0d40051e"
	],
	"./News11.vue": [
		"bed8",
		"chunk-9af8718a"
	],
	"./News13.vue": [
		"f0b8",
		"chunk-6d459d46"
	],
	"./News14.vue": [
		"f6f0",
		"chunk-e5a68684"
	],
	"./News16.vue": [
		"d695",
		"chunk-786d3882"
	],
	"./News18.vue": [
		"9ed0",
		"chunk-92edc804"
	],
	"./News20.vue": [
		"4380",
		"chunk-070c4a7e"
	],
	"./News21.vue": [
		"acf9",
		"chunk-64a9603f"
	],
	"./News23.vue": [
		"b25b",
		"chunk-5c63d0fc"
	],
	"./News24.vue": [
		"b8c8",
		"chunk-4d7ec78a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2ea6";
module.exports = webpackAsyncContext;